import { actionInvalidateVectorTileLayer } from '@tmapy/mapcore';
import { LAYER_IDS } from '@tmapy/config';
import { PREPARE_SAVE_FEATURES } from '../constants';
/**
 * Middleware action called after INTERACTION_MODIFY_FEATURES
 */
export const actionSaveEditedFeatures = (payload) => (dispatch) => {
    if (payload.layerId !== LAYER_IDS.EDIT_TOOLS_HIGHLIGHT &&
        payload.layerId !== LAYER_IDS.EDIT_TOOLS_MODIFY) {
        return;
    }
    const dataToSave = [];
    for (const feature of payload.features) {
        const { _originLayerId, _crs, layerId, ...properties } = feature.properties ?? {};
        if (!_originLayerId)
            continue;
        const requestFeature = {
            ...feature,
            properties,
            crs: _crs,
        };
        dataToSave.push({
            layerId: _originLayerId,
            featureId: feature.id,
            feature: requestFeature,
        });
    }
    if (dataToSave.length) {
        dispatch(actionPrepareSaveFeatures(dataToSave));
    }
};
export const actionPrepareSaveFeatures = (payload) => ({
    type: PREPARE_SAVE_FEATURES,
    payload,
    meta: {
        responsePromise: null,
    },
});
export const actionAfterSaveSuccess = (layerId) => async (dispatch) => {
    dispatch(actionInvalidateVectorTileLayer(layerId));
};
//# sourceMappingURL=saveEditedFeature.js.map